import React from 'react';
import gridStyle from './grid-style.module.less';
import GridHeader from './grid-header';
import GridRows from './grid-rows';

const FiltersGrid = () => {
  return (
    <div className={gridStyle['grid-container']}>
      <GridHeader />
      <GridRows />
    </div>
  );
};

export default FiltersGrid;
